export enum UserStatus {
    UNKNOWN = "UNKNOWN",
    INDIVIDUAL = "INDIVIDUAL",
    LEGAL_ENTITY = "LEGAL_ENTITY",
    ENTREPRENEUR = "ENTREPRENEUR",
}